import HttpFactory from 'http-service-v3'
export default function creativeFactory() {
    const http = HttpFactory()
    return {
      copyAssetV4(payload) {
        return http
          .post(http.wsaDomain + '/creative/v4/template/copyasset', JSON.stringify(payload))
          .then(response => { return response.data })
      },
      uploadQuickStartTemplateAssetV4(fileName, fileContent, templateIds) {
        const formData = new FormData()
        formData.append('file', fileContent, fileName.replace(/[^0-9a-zA-z._-]/g, ''))
        formData.append('templateID', JSON.stringify(templateIds))
        return http
          .post(http.wsaDomain + '/creative/v4/template/temporaryassetupload', formData)
          .then(response => { return {responseData: response.data} })
      },
      uploadQuickStartTemplateAssetFromURLV4(payload) {
        return http
          .post(http.wsaDomain + '/creative/v4/template/temporaryassetuploadfromurl', JSON.stringify(payload))
          .then(response => { return {responseData: response.data} })
      },
    }
  }